import styled from "styled-components";
import cardGithub from "../assets/card-github-animated.gif";
import cardGithubStatic from "../assets/card-github.svg";
import cardPreview from "../assets/card-preview-animated.gif";
import cardPreviewStatic from "../assets/card-preview.svg";
import placeholderImages from "../assets/placeholderImages";
import { useGlobaleContext } from "../context";

const ProjectsList = () => {
  const { paginated_projects, filterProjects } = useGlobaleContext();

  // error i could fetch github projects

  return (
    <Wrapper className="projects-conatainer">
      {paginated_projects.map((project, index) => {
        const { id, name, html_url, description, homepage, topics } = project;

        const imgRandomIndex = (index + Math.floor(Math.random() * 18)) % 18;

        return (
          <article className="card" key={id}>
            <div className="div card-header">
              <img
                src={placeholderImages[imgRandomIndex]}
                alt="place holder"
                className="card--img"
              />
            </div>
            <div className="card-body">
              <div className="card-title">
                <div className="card-topics">
                  {topics.map((topic, index) => (
                    <button
                      className="btn"
                      key={index}
                      onClick={() => filterProjects(topic)}
                    >
                      {topic}
                    </button>
                  ))}
                </div>
                <h5>{name.replaceAll("-", " ")}</h5>
              </div>
              <div className="card-description">
                <p>{description}</p>
              </div>
            </div>
            <div className="card-cta">
              <a
                target="_blank"
                rel="noopener noreferrer"
                aria-label="github repository"
                href={html_url}
                className="card--link"
              >
                <img
                  src={cardGithubStatic}
                  className="static"
                  alt="github repository"
                />
                <img src={cardGithub} alt="github repository" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                aria-label="project preview"
                href={homepage}
                className="card--link"
              >
                <img
                  src={cardPreviewStatic}
                  className="static"
                  alt="project preview"
                />
                <img src={cardPreview} alt="project preview" />
              </a>
            </div>
          </article>
        );
      })}
    </Wrapper>
  );

  // 4 cols 1110px <  1537
  //2 rows  766px  > 719px
};

const Wrapper = styled.section`
  display: grid;
  grid-template-columns: repeat(4, minmax(275px, 1fr));
  row-gap: 1vh;
  padding: 0 !important;
  margin: auto 5vw;
  max-width: 87% !important;

  justify-content: space-evenly;
  justify-items: center;
  align-items: center;

  overflow: visible;

  position: relative;

  @media (max-width: 1366px) {
    align-items: center;
    gap: 2rem;
    margin: auto;
  }

  @media (max-width: 1260px) {
    margin-top: 0px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    max-width: 100% !important;
    gap: 23px;
    margin: 0;
    margin-top: 6vh;
  }
  @media (max-width: 635px) {
    grid-template-columns: 1fr;
    .card {
      max-width: 80%;
      max-height: 100vh;
    }
  }

  .card {
    background-color: #fff;
    border-radius: var(--border-radius-m);
    box-shadow: var(--light-shadow);
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 275px;
    max-height: 359px;
    display: block;

    &:hover {
      @media (prefers-reduced-motion: no-preference) {
        box-shadow: 0px 30px 18px -8px rgba(0, 0, 0, 0.1);
        .card--img {
          opacity: 0.3;
          transform: scale(2);
        }
        .card-body {
          background-color: transparent;
        }

        .card-title {
          margin-bottom: 0rem;
        }
      }
      .card-cta {
        transform: translateX(0);
      }
    }

    &,
    & > * {
      margin: 0;
      padding: 0;
    }

    &-header {
      position: relative;
      height: 100%;
    }

    &--img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: all 0.4s cubic-bezier(0.3, 0.86, 0.32, 0.85);
    }
    &-body {
      background-color: #fff;
      position: absolute;
      inset: 50% 0 0 0;
      padding: 0.5rem 1.5rem 1.5rem;
    }
    &-title {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      row-gap: 1rem;

      margin-bottom: 2rem;

      h5 {
        font-size: 2rem;
      }
    }

    .btn {
      margin: 0;
      margin-right: 1rem;
      padding: 0;
      border: none;

      width: fit-content;

      color: var(--clr-grey-3);
      font-size: 1.4rem;

      &:hover {
        color: var(--clr-grey-1);
        text-decoration: underline;
        background: none;
      }
    }

    &-cta {
      opacity: 0.8;
      position: absolute;
      inset: 0 auto auto 0;
      padding: 0.5rem;
      background-color: #fff;
      border-radius: 0 0 var(--border-radius-m) 0;
      transform: translateX(-100%);
      transition: 0.4s all ease-out;
    }

    &--link {
      display: block;
      width: 4rem;
      position: relative;

      & > img {
        width: 4rem;
      }

      &:hover {
        .static {
          opacity: 0;
        }
      }
    }
    .static {
      position: absolute;
      inset: auto;
      background-color: white;
    }
  }

  @media (max-width: 812px) {
    .card-cta {
      transform: translateX(0);
    }
  }
`;
export default ProjectsList;
